import { capitalize } from '../../../helpers/string-helpers';
import { Vessel } from '../../../../services/store/modules/vessels/models';
import { formatVesselRecordLength } from './vessel-length';

export const getWatercraftListLabel = (vessel: Vessel): string => {
  const typeLabel = capitalize(vessel.watercraft_type || '');
  if (vessel.name) {
    return `${vessel.name} - ${typeLabel}`;
  }
  return typeLabel;
};

// Primary line of the shared watercraft list item: the watercraft name, falling
// back to the type when no name has been set.
export const getWatercraftName = (vessel: Vessel): string =>
  vessel.name || capitalize(vessel.watercraft_type || '');

// Secondary line of the shared watercraft list item: "<type> - <length>", where
// the length uses the unit of measurement set on the watercraft record.
export const getWatercraftTypeLengthLabel = (vessel: Vessel): string => {
  const typeLabel = capitalize(vessel.watercraft_type || '');
  const lengthLabel = formatVesselRecordLength(vessel);

  if (typeLabel && lengthLabel) {
    return `${typeLabel} - ${lengthLabel}`;
  }

  return typeLabel || lengthLabel;
};
